/**
 * Auth store con Zustand — manejo de sesión, usuario y roles
 */
import { create } from 'zustand';
import client from '../api/client';

const useAuthStore = create((set, get) => ({
  user: null,
  roles: [],
  isAuthenticated: false,
  isLoading: true,
  mustChangePassword: false,

  // Inicializar sesión desde tokens existentes
  initialize: async () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      set({ isLoading: false, isAuthenticated: false });
      return;
    }

    try {
      const response = await client.get('/auth/me');
      set({
        user: response.data,
        roles: response.data.roles || [],
        isAuthenticated: true,
        mustChangePassword: response.data.must_change_password,
        isLoading: false,
      });
    } catch (error) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      set({ isLoading: false, isAuthenticated: false });
    }
  },

  // Login local
  login: async (username, password) => {
    const response = await client.post('/auth/login', { username, password });
    const { access_token, refresh_token, must_change_password } = response.data;

    localStorage.setItem('access_token', access_token);
    localStorage.setItem('refresh_token', refresh_token);

    // Obtener info del usuario
    const meResponse = await client.get('/auth/me');
    set({
      user: meResponse.data,
      roles: meResponse.data.roles || [],
      isAuthenticated: true,
      mustChangePassword: must_change_password,
    });

    return { must_change_password };
  },

  // Login OAuth callback
  loginWithTokens: async (accessToken, refreshToken, mustChangePassword) => {
    localStorage.setItem('access_token', accessToken);
    localStorage.setItem('refresh_token', refreshToken);

    const meResponse = await client.get('/auth/me');
    set({
      user: meResponse.data,
      roles: meResponse.data.roles || [],
      isAuthenticated: true,
      mustChangePassword: mustChangePassword === 'true',
    });
  },

  // Cambiar contraseña
  changePassword: async (currentPassword, newPassword) => {
    await client.put('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });
    set({ mustChangePassword: false });
  },

  // Logout
  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    set({
      user: null,
      roles: [],
      isAuthenticated: false,
      mustChangePassword: false,
    });
  },

  // Helpers
  isAdmin: () => get().roles.includes('ADMIN'),
  isManager: () => get().roles.includes('MANAGER'),
  isAdminOrManager: () => get().roles.includes('ADMIN') || get().roles.includes('MANAGER'),
  hasRole: (role) => get().roles.includes(role),
}));

export default useAuthStore;
